import React from "react";

const Footer = props => (
  <footer id="footer">
    <div className="footer_container">
      <div className="inner">
        <div className="copyright">
          <span> All rights reserved @2018 Powered by XCITE </span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
